// HomeRedes.js
import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import imagen_celular from "../../images/celular_redes.png";
import globitos from "../../images/globitos_redes.png";

// utilidad rápida
const isValidUrl = (url) => {
  try {
    return Boolean(new URL(url));
  } catch {
    return false;
  }
};

const HomeRedes = ({ infoCompany }) => {

  return (
    <div className="redes-company" style={{ backgroundColor: 'var(--theme-visit)' }}>
      {/* ---------- títulos ---------- */}
      <div className="title-redes">
        <div className="title-redes-one">
          <span style={{ color: 'var(--theme-visit)' }}>Siguenos en nuestras</span>
        </div>
        <div className="title-redes-two">
          <span style={{ color: 'var(--theme-main)' }}>Redes Sociales</span>
        </div>
        <div className="title-redes-two-celular">
          <span style={{ color: 'var(--theme-visit)' }}>Redes Sociales</span>
        </div>
      </div>

      {/* ---------- fila 1 ---------- */}
      <div className="redes-one">
        <div className="social-links">
          {/* WhatsApp */}
          <div className="section-social">
            <a
              href={
                isValidUrl(infoCompany?.wp_url)
                  ? infoCompany.wp_url
                  : "#"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                className="icon"
                style={{
                  fontSize: 40, left: 20, top: 16, color: 'var(--theme-visit)'
                }}
              />
            </a>
          </div>

          {/* Tiktok */}
          <div className="section-social">
            <a
              href={
                isValidUrl(infoCompany?.tiktok_url)
                  ? infoCompany.tiktok_url
                  : "#"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faTiktok}
                className="icon"
                style={{
                  fontSize: 35,
                  left: 22,
                  color: 'var(--theme-visit)',

                }}
              />
            </a>
          </div>
        </div>
      </div>

      {/* ---------- fila 2 ---------- */}
      <div className="redes-two">
        <div className="social-links">
          {/* Facebook */}
          <div className="section-social red-fb">
            <a
              href={
                isValidUrl(infoCompany?.fb_url) ? infoCompany.fb_url : "#"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faFacebookF}
                className="icon"
                style={{
                  color: 'var(--theme-visit)',
                  fontSize: 40,
                  position: "relative",
                  left: '23px',
                  top: '16px',
                }}
              />
            </a>
          </div>

          {/* Instagram */}
          <div className="section-social">
            <a
              href={
                isValidUrl(infoCompany?.ig_url) ? infoCompany.ig_url : "#"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                className="icon"
                style={{ fontSize: 40, left: 19 , color: 'var(--theme-visit)'}}
              />
            </a>
          </div>
        </div>
      </div>

      {/* ---------- imagen decorativa ---------- */}
      <div className="redes-photo">
        <div className="section-social-globitos">
          <img src={globitos} alt="globitos" className="globitos-img" />
          <div className="section-social-photo">
            <img
              src={imagen_celular}
              alt="celular"
              className="celular-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeRedes;
